export default {
  "nav.home": "首页",
  "nav.features": "功能介绍",
  "nav.guide": "使用指南",
  "nav.scenarios": "适用场景",
  "nav.reviews": "用户评价",
  "nav.about": "关于我们",
  "nav.register": "免费注册",
  "nav.login": "登录",
  "footer.copyright": "© 2026 hlw. 保留所有权利.",
  "footer.about": "关于我们",
  "footer.contact": "联系我们",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "home.hero.title": "hlw 让技术更简单",
  "home.hero.subtitle": "值得信赖的一站式数字化解决方案，助力企业高效构建、部署和管理应用，开启智能时代新篇章",
  "home.hero.cta": "免费开始使用",
  "home.hero.secondary": "了解更多",
  "home.features.title": "核心功能",
  "home.features.subtitle": "六大核心能力，全方位满足企业数字化需求",
  "home.advantages.title": "为什么选择 hlw",
  "home.advantages.subtitle": "数据会说话，看看 hlw 为您的企业带来的改变",
  "home.scenarios.title": "适用场景",
  "home.scenarios.subtitle": "覆盖多个行业，为不同业务场景提供定制化解决方案",
  "home.testimonials.title": "用户评价",
  "home.testimonials.subtitle": "来自 10,000+ 企业客户的真实反馈",
  "home.cta.title": "准备好开始了吗？",
  "home.cta.subtitle": "立即注册 hlw 账号，开启 14 天免费试用，体验数字化升级带来的改变",
  "home.cta.button": "立即免费注册",
  "category.all": "全部",
  "category.readMore": "阅读全文",
  "category.noArticles": "暂无相关文章",
  "article.backToList": "返回列表",
  "article.relatedArticles": "相关文章",
  "article.author": "作者",
  "article.date": "发布日期",
  "article.readTime": "阅读时长",
  "article.tags": "标签",
  "about.brand.title": "品牌故事",
  "about.values.title": "核心价值观",
  "about.milestones.title": "发展历程",
  "about.reputation.title": "荣誉与资质",
  "about.faq.title": "常见问题",
  "about.contact.title": "联系我们",
  "about.contact.submit": "发送消息",
  "about.contact.success": "消息已发送，我们会尽快与您取得联系！",
  "breadcrumb.home": "首页",
  "form.name": "姓名",
  "form.email": "电子邮箱",
  "form.phone": "联系电话",
  "form.company": "公司名称",
  "form.message": "留言内容",
  "form.namePlaceholder": "请输入您的姓名",
  "form.emailPlaceholder": "请输入您的电子邮箱",
  "form.phonePlaceholder": "请输入您的联系电话",
  "form.companyPlaceholder": "请输入您的公司名称",
  "form.messagePlaceholder": "请输入您想咨询的内容（限 500 字）",
};